var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { applicationLoaderActionTypes } from './ApplicationLoader.types';
var initialState = {
    show: false,
    text: '',
    loadingApp: false,
};
export var applicationLoaderReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case applicationLoaderActionTypes.SHOW_APPLICATION_LOADER:
            return __assign(__assign({}, state), { show: true, text: action.text, loadingApp: true });
        case applicationLoaderActionTypes.HIDE_APPLICATION_LOADER:
            return __assign(__assign({}, state), { show: false, text: '', loadingApp: false });
        default:
            return state;
    }
};
